import { render } from "./car-number.vue?vue&type=template&id=73999c82&scoped=true"
import script from "./car-number.vue?vue&type=script&lang=js"
export * from "./car-number.vue?vue&type=script&lang=js"

import "./car-number.vue?vue&type=style&index=0&id=73999c82&lang=scss&scoped=true"

import exportComponent from "/var/www/toll-collector/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73999c82"]])

export default __exports__